import './App.css';
import { ThemeProvider } from '@mui/material';
import theme from './theme';
import CssBaseline from '@mui/material/CssBaseline';
import "swiper/css";
import "swiper/css/navigation";
import { Routes, Route } from "react-router-dom";
import PublicRoutes from './routes/PublicRoutes';
import ScrollToTop from './components/ScrollToTop';
import ClearStorageHandler from './components/common/ClearStorageHandler';

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ScrollToTop />
         <ClearStorageHandler />
        <Routes>
          <Route path="/*" element={<PublicRoutes />} />
        </Routes>
      </ThemeProvider>
    </>
  );
}

export default App;
